import { render } from "./Answers.vue?vue&type=template&id=1e4c7fd0&ts=true"
import script from "./Answers.vue?vue&type=script&lang=ts"
export * from "./Answers.vue?vue&type=script&lang=ts"

import "./Answers.vue?vue&type=style&index=0&id=1e4c7fd0&lang=scss"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__